import React from 'react'
import styled from 'styled-components'

import { CloseIcon, Typography } from '@blade/ui-kit'
import { ChevronLeftIcon } from '@root/shared/ui-kit'

type Props = {
  title: React.ReactNode
  onClose?: () => void
  onBack?: () => void
}

export const PremiumDialogHeader: React.FC<Props> = ({
  title,
  onClose,
  onBack,
}) => {
  return (
    <Root>
      {onBack ? (
        <Icon onClick={onBack}>
          <ChevronLeftIcon size={16} />
        </Icon>
      ) : (
        <span />
      )}
      <Title>{title}</Title>
      <Close size={20} onClick={onClose} />
    </Root>
  )
}

const Root = styled.header`
  background: var(--background-2);

  display: grid;
  align-items: center;
  grid-template-columns: minmax(20px, auto) 1fr auto;

  height: 40px;
  gap: 8px;

  padding-inline: 14px;
`

const Title = styled(Typography).attrs({
  variant: 'body2-semi-bold',
  component: 'h2',
})`
  color: var(--white);
  text-align: center;
`

const Icon = styled.div`
  display: grid;
  justify-content: center;
  align-items: center;
  cursor: pointer;

  color: var(--text-10);
  &:hover {
    color: var(--text-11);
  }

  transition: color 0.2s ease-in-out;
`

const Close = styled(CloseIcon)`
  color: var(--textA-8);

  cursor: pointer;

  transition: color 0.2s ease-in-out;

  &:hover {
    color: var(--text-12);
  }
`
